function DividerOptions() {
  const options = []

  return options
}

export default DividerOptions
